import { observer, inject } from 'mobx-react'
import React, { Component } from 'react'
import User from '../../store/user.store'
import t from '../../service/translate.service'
import { autorun, extendObservable } from 'mobx'
import faqCategoryStore from '../../store/admin/FaqCategory.store'
import { Form, Image, Button } from 'react-bootstrap'
import history from '../../service/history.service'
import { availableLinks } from '../../config'
import PropTypes from 'prop-types'
import { Textarea } from '../../components/formComponents'
import Emitter from '../../service/event.emitter'
import ThankYouOverlay from '../../components/ThankYouOverlay'
import withRouter from '../../components/withRouter'
import { Link } from "react-router-dom";
import { Alert } from 'antd'

class FaqList extends Component {

    static propTypes = {
      faqFeedbackStore: PropTypes.object.isRequired
    }
    constructor (props) {
      super(props)
      this.inputRefs = [
        React.createRef()
      ]
      extendObservable(this, {
        category: null,
        locale: 'De',
        feedbackRef: null,
        submitted: false,
        errorsList: [],
        errorListVoice: false
      })
      autorun(() => {
        this.props.faqFeedbackStore.resetForm()
      })
      this.getCategory()

      if (t.locale === 'en') this.locale = ''
      else this.locale = t.locale.charAt(0).toUpperCase() + t.locale.slice(1)
    }

    getCategory = () => {
    const id = this.props.useParams.id
    faqCategoryStore.findOne(parseInt(id)).then((category) => {
      this.category = category
    })
  }

    getAttrs = field => {
      const { model, setVal, validators, alertValidators } = this.props.faqFeedbackStore
      return {
        value: model[field],
        onChange: e => {
          this.errorListVoice = false
          setVal(field, e.target.value)
        },
        validate: validators[field],
        blurValidate: alertValidators[field]
      }
    }

    getAttrs = field => {
      const { model, setVal, validators, alertValidators } = this.props.faqFeedbackStore
      return {
        value: model[field],
        onChange: e => setVal(field, e.target.value),
        validate: validators[field],
        blurValidate: alertValidators[field]
      }
    }

    handleLinkClick = (link) => {

      if (link.includes('phone_numbers') || link.includes('contact')) {
        if (this.feedbackRef) this.feedbackRef.scrollIntoView({ behavior: 'smooth' })
      } else if (link.includes('chat')) {
        Emitter.emit('openChat', {})
      } else if (link.includes('apartment_search')) {
        window.open('https://www.grandcityproperty.de/wohnungssuche', '_blank')
      } else {
        this.props.navigate(availableLinks.find(l => l.type === link).to)
      }
    }

    generateErrorList = () => {
      const errors = []
      for (let i = 0; i < this.inputRefs.length; i++) {
        const inputRef = this?.inputRefs[i]?.current
        if (i === 0) {
          const val = inputRef?.value
          const label = inputRef?.ariaLabel
          const error = this.props.faqFeedbackStore.alertValidators['feedback'](val, label)
          if (error) {
            errors.push(
              <button
                key={1}
                type='button'
                onClick={() => {
                  inputRef.focus()
                }}
              >
                {error}
              </button>
            )
          }
        }
      }
      return errors
    }

    AlertContent = () => {
      const errorsList = this.errorsList
      const errorListVoice = this.errorListVoice
      if (errorsList?.length > 0) {
        return (
          <Alert
            role={errorListVoice ? "alert" : "none"}
            message={
              <div
                className='error-list'
                role={errorListVoice ? "alert" : "none"}
                aria-live={errorListVoice ? "assertive" : "off"}
              >
                {t.REQUIRED_FIELD_MISSING}
                {errorsList?.map((err) => {
                  return err
                })}
              </div>
            }
            type='error'
            style={{ marginTop: '12px', marginBottom: '12px' }}
          />
        )
      } else {
        return (<></>)
      }
    }

    submitFeedback = (e) => {
      e.preventDefault()
      this.submitted = false
      setTimeout(() => {
        this.errorsList = this.generateErrorList()
        this.errorListVoice = true
        this.submitted = true
      }, 100)
      this.props.faqFeedbackStore.submit()
    }
    handleBack = () => {
      this.props.faqFeedbackStore.resetForm()
    }

    render () {
      return (
        <div>
          {this.props.faqFeedbackStore.showThankYouPage ? (
            <ThankYouOverlay
              title={t.THANK_YOU}
              description={t.FEEDBACK_THANK_YOU}
              buttonText={t.BACK_TO_FAQ}
              buttonLink='/faq'
              handleClick={this.handleBack}
            />
          ) : (
            <div className='faq-questions-list'>
              {this.category && (
                <div>
                  <div className='title secondary'>
                    {this.category[`name${this.locale}`]}
                  </div>
                  {this.category?.faqQuestions?.map((question) => {
                    let links = [];
                    if (question.links) {
                      var translated = JSON.parse(question.links);
                      if (translated && translated !== null) {
                        links = translated;
                        if (!User.user.tenant) {
                          links = links?.filter(
                            (link) =>
                              link === 'contact' ||
                              link === 'apartment_search' ||
                              link === 'phone_numbers'
                          );
                        }
                      }
                    }
                    return (
                      <div className='faq-question-wrap' key={question.id}>
                        <div className='faq-question'>{question[`question${this.locale}`]}</div>
                        <div className='faq-answer'>{question[`answer${this.locale}`]}</div>
      
                        {question.image && (
                          <Image className='faq-image' src={question.image} alt={question[`question${this.locale}`]} />
                        )}
      
                        <div className='faq-links'>
                          {question.linksText && (
                            <div className='faq-links-text'>
                              {question[`linksText${this.locale}`]}&nbsp;
                            </div>
                          )}
                          {!!links.length &&
                            links?.map((link, index) => (
                              <div className='faq-link' key={link}>
                                <button onClick={() => this.handleLinkClick(link)}>
                                  {availableLinks.find(l => l.type === link)[`name${this.locale}`]}
                                </button>
                                {index !== links.length - 1 && <span>,&nbsp;</span>}
                              </div>
                            ))}
                          </div>

                          <div className='faq-contact-text'>
                            <div>
                              <span>{t.MAIN_FAQ_CONTACT_US_1}</span>&nbsp;
                              <button className='faq-link' onClick={() => this.handleLinkClick('contact')}>{t.MAIN_FAQ_CONTACT_US_2}</button>&nbsp;
                              <span>{t.MAIN_FAQ_CONTACT_US_3}</span>
                            </div>
                          </div>
                        </div>
                    );
                  })}
                </div>
              )}

              <div className='faq-form' ref={(el) => { this.feedbackRef = el }}>
                <div className='faq-form-title'>{t.MAIN_FAQ_FEEDBACK_TEXT}</div>
                <Form>
                  {this.submitted && (
                    <this.AlertContent />
                  )}
                  <Textarea
                    ref={this.inputRefs[0]}
                    {...this.getAttrs('feedback')}
                    name='feedback'
                    label='Feedback'
                    aria-label={t.MAIN_FAQ_FEEDBACK_TEXT}
                    required={true}
                  />
                  <Form.Group className='text-center'>
                    <button
                      type='submit'
                      className='button primary'
                      aria-label={t.MAIN_FAQ_SUBMIT}
                      onClick={this.submitFeedback}
                    >
                      {t.MAIN_FAQ_SUBMIT}
                    </button>
                  </Form.Group>
                </Form>
              </div>
            </div>
          )}
        </div>
      );
    }
}

export default inject('faqFeedbackStore')(withRouter(observer(FaqList)))
